import React from "react";
import "./ServicesArea.scss";
import Waves from "../../components/otherComponents/Waves/Waves";
import { FaMapLocationDot } from "react-icons/fa6";

function ServicesArea() {
  const areasLinks = [
    {
      icon: <FaMapLocationDot />,
      town: "Willow Creek",
      link: "https://maps.app.goo.gl/P3JFV5deWDEwEQBL8",
    },
    {
      icon: <FaMapLocationDot />,
      town: "Three Forks",
      link: "",
    },
    {
      icon: <FaMapLocationDot />,
      town: "",
      link: "",
    },
    {
      icon: <FaMapLocationDot />,
      town: "",
      link: "",
    },
    {
      icon: <FaMapLocationDot />,
      town: "",
      link: "",
    },
    {
      icon: <FaMapLocationDot />,
      town: "",
      link: "",
    },
    {
      icon: <FaMapLocationDot />,
      town: "",
      link: "",
    },
    {
      icon: <FaMapLocationDot />,
      town: "",
      link: "",
    },
    {
      icon: <FaMapLocationDot />,
      town: "",
      link: "",
    },
  ];
  return (
    <div>
      <section className="heroAreas">
        <div className="content">
          <h1>Epoxy Drywall & Paint Locations</h1>
          <div className="option"></div>
        </div>
        <Waves />
      </section>
      <section className="areas">
        <h1 className="sectionTitle">Service Areas</h1>
        <ul>
          {areasLinks.map(({ icon, town, link }, index) => (
            <li key={index}>
              <a
                href={link}
                target="_blank"
                rel="noopener noreferrer"
                className="contact-icon"
              >
                <span>{icon}</span>
                {town}
              </a>
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}

export default ServicesArea;
